// Angular
import { Component, OnInit } from '@angular/core';
// Layout
import { LayoutConfigService } from '../../../core/_base/layout';
// Object-Path
import * as objectPath from 'object-path';
import { AuthService, Logout } from 'app/core/auth';
import { Store } from '@ngrx/store';
import { AppState } from 'app/core/reducers';
import { Router } from '@angular/router';

@Component({
  standalone: false,
	selector: 'kt-footer',
	templateUrl: './footer.component.html',
	 styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
	// Public properties
	today: number = Date.now();
	fluid: boolean;
	isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
	/**
	 * Component constructor
	 *
	 * @param layoutConfigService: LayouConfigService
	 */
	constructor(private layoutConfigService: LayoutConfigService, private store: Store<AppState>,
        private authService: AuthService,private router: Router) {
	}

	/**
     * Log out
     */
	 logout() {
        this.authService.logout(null, true)
            .subscribe(logoutDone => {
                if (logoutDone) {
                    this.store.dispatch(new Logout());
                }
            });
    }

	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * On init
	 */
	ngOnInit(): void {
		const config = this.layoutConfigService.getConfig();

		// footer width fluid
		this.fluid = objectPath.get(config, 'footer.self.width') === 'fluid';
		this.isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
	}

	goToFavorites()
	{
		let element: HTMLElement = document.getElementsByClassName('kt-header-mobile__toggler')[0] as HTMLElement;
		element.click();
		let element2: HTMLElement = document.getElementsByClassName('fa fa-star')[0] as HTMLElement;
		element2.click();
	}

	isDashboard()
	{
		if(this.router.url == '/dashboard/dashboard')
		{
			return true;
		}
		else {
			return false;
		}
	}
}
